module.exports = __webpack_public_path__ + "static/media/drops2x.82a54b38.png";